import axios from 'axios';

class FlutterwaveService {
    static getApiBaseURL() {
        if (process.env.MIX_FLUTTERWAVE_MODE === 'sandbox') {
            return process.env.MIX_FLUTTERWAVE_SANDBOX_API_URL;
        }
        return process.env.MIX_FLUTTERWAVE_API_URL;
    }

    static isBanksAvailable(abbreviation) {
        const supportedCountries = [
            'NG',
            'GH',
            'KE',
            'UG',
            'ZA',
            'TZ',
            'CI',
        ];
        return supportedCountries.indexOf(abbreviation) >= 0;
    }

    static async getBanksByCountry(countryCode) {
        if (!process.env.MIX_FLUTTERWAVE_PUBLIC_KEY) {
            return Promise.reject(new Error('Missed MIX_FLUTTERWAVE_PUBLIC_KEY environment variable'));
        }

        try {
            const publicKey = process.env.MIX_FLUTTERWAVE_PUBLIC_KEY;
            const url = `${this.getApiBaseURL()}/v2/banks/${countryCode}?public_key=${publicKey}`;
            const { data } = await axios.get(url);
            return data.data.Banks;
        } catch (err) {
            return this.processError(err);
        }
    }

    static getBranchesByBankId(bankId) {
        if (!process.env.MIX_FLUTTERWAVE_PUBLIC_KEY) {
            return Promise.reject(new Error('Missed MIX_FLUTTERWAVE_PUBLIC_KEY environment variable'));
        }

        const publicKey = process.env.MIX_FLUTTERWAVE_PUBLIC_KEY;
        const url = `${this.getApiBaseURL()}/v2/banks/branches/${bankId}?public_key=${publicKey}`;
        return axios.get(url).then((response) => response.data.data.Data);
    }

    static async verifyAccount(recipientAccount, destBankCode) {
        if (!process.env.MIX_FLUTTERWAVE_PUBLIC_KEY) {
            return Promise.reject(new Error('Missed MIX_FLUTTERWAVE_PUBLIC_KEY environment variable'));
        }

        try {
            const publicKey = process.env.MIX_FLUTTERWAVE_PUBLIC_KEY;
            const url = `${this.getApiBaseURL()}/flwv3-pug/getpaidx/api/resolve_account`;
            const payload = {
                recipientaccount: recipientAccount,
                destbankcode: destBankCode,
                PBFPubKey: publicKey,
            };
            const { data } = await axios.post(url, payload);
            return data;
        } catch (err) {
            return this.processError(err);
        }
    }

    static processError(err) {
        if (err.isAxiosError) {
            throw new Error(err.response.data.message);
        } else {
            throw new Error(err.message);
        }
    }
}

export default FlutterwaveService;
